import React from 'react';
import { buildRateVolumeRows, formatAccounting, formatRate } from './boardPackHelpers';

const renderCell = (value, formatter = formatAccounting) => {
  if (value === null || value === undefined) return '—';
  const formatted = formatter === formatRate ? formatRate(value) : formatter(value);
  return formatted ?? '—';
};

const varianceTone = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n === 0) return '';
  return n < 0 ? 'bp-negative' : 'bp-positive';
};

export default function BoardPackRateVolume({ lineBridgePairs }) {
  const rows = buildRateVolumeRows(lineBridgePairs);

  if (!rows.length) return null;

  return (
    <section className="ace-panel bp-section">
      <div className="ace-eyebrow">BP_04 <span aria-hidden>●</span> Rate / volume analysis</div>
      <div className="bp-table-wrap">
        <table className="bp-table bp-rv-table">
          <thead>
            <tr>
              <th>Line</th>
              <th className="bp-amount">Avg balance (ref)</th>
              <th className="bp-amount">Avg balance (act)</th>
              <th className="bp-amount">Rate (ref)</th>
              <th className="bp-amount">Rate (act)</th>
              <th className="bp-amount">Δ due to volume</th>
              <th className="bp-amount">Δ due to rate</th>
              <th className="bp-amount">Δ due to mix</th>
              <th className="bp-amount">Total</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.key}>
                <td><strong>{row.line}</strong></td>
                <td className="bp-mono bp-amount">{renderCell(row.balanceRef)}</td>
                <td className="bp-mono bp-amount">{renderCell(row.balanceAct)}</td>
                <td className="bp-mono bp-amount">{renderCell(row.rateRef, formatRate)}</td>
                <td className="bp-mono bp-amount">{renderCell(row.rateAct, formatRate)}</td>
                <td className={`bp-mono bp-amount ${varianceTone(row.volumeDelta)}`}>
                  {renderCell(row.volumeDelta)}
                </td>
                <td className={`bp-mono bp-amount ${varianceTone(row.rateDelta)}`}>
                  {renderCell(row.rateDelta)}
                </td>
                <td className={`bp-mono bp-amount ${varianceTone(row.mixDelta)}`}>
                  {renderCell(row.mixDelta)}
                </td>
                <td className={`bp-mono bp-amount ${varianceTone(row.total)}`}>
                  {renderCell(row.total)}
                </td>
                <td>
                  {row.source ? (
                    <span className="ace-pill bp-source-chip">{row.source}</span>
                  ) : (
                    '—'
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="bp-footnote">
        Decomposition from the deterministic bridge engine; source per line.
      </p>
    </section>
  );
}
